import { Suspense, lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Spinner, Text, tokens } from '@fluentui/react-components';
import LayoutShell from './components/LayoutShell';

// Lazy load pages for code splitting
const DashboardPage = lazy(() => import('./pages/DashboardPage'));
const RenameWorkspacePage = lazy(() => import('./pages/RenameWorkspacePage'));
const TransactionLogPage = lazy(() => import('./pages/TransactionLogPage'));
const ReviewRequestsPage = lazy(() => import('./pages/ReviewRequestsPage'));
const ConfigurationPage = lazy(() => import('./pages/ConfigurationPage'));

// Loading fallback component
const PageLoader = () => (
  <div style={{ 
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'center',
    gap: tokens.spacingHorizontalM,
    minHeight: '200px'
  }}>
    <Spinner size="medium" />
    <Text>Loading...</Text>
  </div>
);

function App() {
  return (
    <LayoutShell>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/rename" element={<RenameWorkspacePage />} />
          <Route path="/review" element={<ReviewRequestsPage />} />
          <Route path="/config" element={<ConfigurationPage />} />
          <Route path="/transactions" element={<TransactionLogPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
    </LayoutShell>
  );
}

export default App;
